import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceCaseTypes, efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import updateServiceAssignment from './updateServiceAssignment';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';
import * as serviceAssignmentActionTypes from '../serviceAssignmentActionTypes';

/**
 * Update service assignment damage location info flow
 */
const updateServiceAssignmentDamageLocationInfoForm = function* updateServiceAssignmentDamageLocationInfoForm() {
    while (true) {
        const {payload} = yield take(serviceAssignmentActionTypes.SUBMIT_SERVICE_ASSIGNMENT_DAMAGE_LOCATION_INFO_FORM);
        const {serviceCaseData, serviceCaseId, serviceAssignmentLineNo} = payload;
        const {serviceCaseCallbackPhoneNoData} = payload;

        yield* updateServiceCase({
            caller: serviceAssignmentActionTypes.SUBMIT_SERVICE_ASSIGNMENT_DAMAGE_LOCATION_INFO_FORM,
            caseType: efServiceCaseTypes.VEHICLE,
            serviceCaseId,
            serviceCaseData,
        });

        const {callbackPhoneNo, unknownCallbackPhoneNo, secondCallbackPhoneNo} = serviceCaseCallbackPhoneNoData;
        yield put({
            type: serviceCaseActionTypes.SET_IS_CALLBACK_PHONE_NUMBER_VALID,
            payload: {
                serviceCaseId,
                callbackPhoneNo,
                unknownCallbackPhoneNo,
                isCallbackPhoneNoValid: !unknownCallbackPhoneNo ? callbackPhoneNo !== '' : true,
            },
        });

        yield* updateServiceCase({
            caller: serviceAssignmentActionTypes.SUBMIT_SERVICE_ASSIGNMENT_DAMAGE_LOCATION_INFO_CALLBACK_PHONE_NUMBER_FORM, // eslint-disable-line max-len
            caseType: efServiceCaseTypes.VEHICLE,
            serviceCaseId,
            serviceCaseData: {
                callbackPhoneNo,
                unknownCallbackPhoneNo,
            },
        });

        yield* updateServiceAssignment({
            caller: serviceAssignmentActionTypes.SUBMIT_SERVICE_ASSIGNMENT_DAMAGE_LOCATION_INFO_CALLBACK_PHONE_NUMBER_FORM, // eslint-disable-line max-len
            assignmentType: efServiceAssignmentTypes.VEHICLE,
            serviceCaseId,
            serviceAssignmentLineNo,
            serviceAssignmentData: {callbackPhoneNo, secondCallbackPhoneNo},
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: serviceAssignmentActionTypes.SUBMIT_SERVICE_ASSIGNMENT_DAMAGE_LOCATION_INFO_FORM},
        });
    }
};

export default updateServiceAssignmentDamageLocationInfoForm;
